import React, { useState } from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

export let startLoader = () => { };
export let endLoader = () => { };

const Loader = () => {
    const [loader, setLoader] = useState(false);
    const startProgress = () => {
        setLoader(true);
    };

    const completeProgress = () => {
        setTimeout(() => {
            setLoader(false);
        }, 1000);
    };

    startLoader = startProgress;
    endLoader = completeProgress;

    if (loader) {
        return (
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 300 }}
                open={loader}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        );
    }
    return <></>;
};

export default Loader;